import { textColumn } from '@/shared/grids/columns/textColumn';
import { GridColumnSettings } from '@/shared/types/grid';
import { companiesHouseUrl } from '@/shared/utils/url';

export const registrationNumberColumn = <T>(options: {
  uid?: string;
  field: keyof T & string;
}): GridColumnSettings<T> => {
  const { uid, field } = options;

  return textColumn({
    uid,
    field,
    header: 'Reg Number',
    template: `\${if(${field})}<a href="${companiesHouseUrl(`\${${field}}`)}" target="_blank" class="grid-link">\${${field}}</a>\${else}<span class="text-more-muted">Not set</span>\${/if}`,
  });
};
